export default __webpack_public_path__ + "static/media/img3.ad48d37b.jpg";